<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11">
    <g transform="translate(-1.5 -3.5)">
      <path fill="none" stroke="currentColor"
            d="M3.3,4H13.7A1.279,1.279,0,0,1,15,5.25v7.5A1.279,1.279,0,0,1,13.7,14H3.3A1.279,1.279,0,0,1,2,12.75V5.25A1.279,1.279,0,0,1,3.3,4Z"/>
      <path fill="none" stroke="currentColor" d="M15,6,8.5,10.333,2,6" transform="translate(0 -0.741)"/>
    </g>
  </svg>
</template>
